import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "full"];
  static values = { digits: Number, letter: String };

  connect() {
    this.render();
  }

  render() {
    this.fullTarget.textContent = this.fullSerialNumber();
  }

  fullSerialNumber() {
    const typed = this.inputTarget.value.replace(/\s/g, "").toUpperCase();
    const match = typed.match(/^([A-Z])?0*(\d*)$/);
    if (!match || match[2] === "") return "";

    const letter = match[1] || this.letterValue;
    return letter + match[2].padStart(this.digitsValue, "0");
  }
}
